import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const attributes = Object.freeze({
  color: "",
  classes: "",
  size: "24",
});

export default function Add({
  attributes = {
    color: "",
    classes: "",
    size: "",
  },
  clickHandler=()=>{},
}) {
  const navigate = useNavigate();
  return (
    <div className={attributes.classes} onClick={clickHandler}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={attributes.size}
        height={attributes.size}
        viewBox="0 0 16.6 16.6"
      >
        <g
          id="Icon_park-add-one"
          data-name="Icon park-add-one"
          transform="translate(0.5 0.5)"
        >
          <path
            id="Path_11563"
            data-name="Path 11563"
            d="M10.8,18.6A7.8,7.8,0,1,0,3,10.8,7.8,7.8,0,0,0,10.8,18.6Z"
            transform="translate(-3 -3)"
            fill="none"
            stroke={attributes.color}
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_11564"
            data-name="Path 11564"
            d="M15.12,12v6.24M12,15.12h6.24"
            transform="translate(-7.32 -7.32)"
            fill="none"
            stroke={attributes.color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
        </g>
      </svg>
    </div>
  );
}
